module.exports = __webpack_public_path__ + "img/35.446ef3b8.jpg";